import { GridToolbarProps, ToolbarPropsOverrides } from '@mui/x-data-grid-pro';
import AddBoxTwoToneIcon from '@mui/icons-material/AddBoxTwoTone';
import { Button } from '@mui/material';
import classNames from 'classnames/bind';
import { queueModal } from '@components/Modals/modalSlice';
import { useAppDispatch } from '@reduxStore';

import styles from './DataGrid.Contacts.module.css';
const stylesContext = classNames.bind(styles);

export default function ContactsToolbar({ contactToolbarOverrides: { consigneeId }, ...props }: GridToolbarProps & ToolbarPropsOverrides) {
	const appDispatch = useAppDispatch();
	const handleAddContactClick = () => {
		appDispatch(
			queueModal({
				Component: 'contactForm',
				Props: {
					consigneeId,
					contact: null
				}
			})
		);
	};

	const toolbarStyles = stylesContext({
		[props.className ?? '']: Boolean(props.className),
		toolbar: true
	});

	return (
		<div className={toolbarStyles}>
			<h3>Contacts</h3>

			<Button
				variant='contained'
				endIcon={<AddBoxTwoToneIcon />}
				className={styles['add-btn']}
				color='secondary'
				onClick={handleAddContactClick}
			>
				<span className={styles['text']}>Add</span>
			</Button>
		</div>
	);
}
